<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title> {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.PAGE_TITLE' | translate }} </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button [previousPageUrl]="previousPageUrl"> </glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <button mat-flat-button type="button" (click)="createNewPipeline()" color="primary">
        {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.BUTTONS.CREATE' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  @if (pipelines$ | async; as pipelines) {
    <glxy-in-page-nav [toggleLabel]="'FRONTEND.SALES_UI.PIPELINE.PIPELINES'">
      <glxy-nav-layout>
        <glxy-nav-item *ngFor="let pipeline of pipelines" [route]="pipeline.pipelineId">{{
          pipeline.name
        }}</glxy-nav-item>
      </glxy-nav-layout>
      <div class="form-page">
        <router-outlet></router-outlet>
      </div>
    </glxy-in-page-nav>
  } @else {
    <glxy-loading-spinner [fullHeight]="true" [size]="'large'"></glxy-loading-spinner>
  }
</glxy-page>
